import { ArrayDataSource } from '@angular/cdk/collections';
import { NgStyle } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Estimate } from 'src/app/models/Estimate';
import { EstimateType } from 'src/app/models/EstimateType';
import { Tecnologia } from 'src/app/models/Tecnologia';
import { ApiEstimativaService } from 'src/app/modules/shared/services/api-estimativa.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { LanguageService } from 'src/app/modules/shared/services/language.service';
import { ProjectsService } from 'src/app/modules/shared/services/projects.service';
import { TecnologiasService } from 'src/app/modules/shared/services/tecnologias.service';
import { UsersManagementService } from 'src/app/modules/shared/services/usersManagement.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Review } from 'src/app/models/Review';
import { Criticality } from 'src/app/models/Criticality';
import { EditedBy } from 'src/app/models/EditedBy';
import { GCMService } from 'src/app/modules/shared/services/gcm.service';
import { MatIconModule } from '@angular/material/icon';
import { EditValueDialogComponent } from '../edit-value-dialog/edit-value-dialog.component';
import { retryWhen, catchError, scan, delay, filter, switchMap, take } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CatalogService } from 'src/app/modules/shared/services/catalog.service';
import { InfoBarWithStatusService } from 'src/app/modules/shared/services/info-bar-with-status.service';
import { getEstimationErrorMessages } from 'src/app/constants/estimation-error-messages';
import { AuthService } from 'src/app/modules/shared/services/auth.service';
import { EstimationState } from 'src/app/models/EstimationState';
import { ProfileService } from 'src/app/modules/shared/services/profile.service';
import { ProfileSelectorDialogComponent } from '../profile-selector-dialog/profile-selector-dialog.component';
import { NotificationsService } from 'src/app/modules/shared/services/notifications.service';
import { AiGenerateDialogComponent } from '../ai-generate-dialog/ai-generate-dialog.component';
import {
  hasAiGeneratedMacros,
  hasAiGeneratedMacrosInForm,
  hasAiGeneratedSubTasks,
  isAiGeneratedItem
} from '../ai-estimate.utils';
import { GenericDialogComponent } from 'src/app/modules/shared/generic-dialog/generic-dialog.component';

@Component({
  standalone: false,
  selector: 'app-custom-stepper',
  templateUrl: './custom-stepper.component.html',
  styleUrls: ['./custom-stepper.component.css']
})
export class CustomStepperComponent implements OnInit {
  @Input() estimate: any = null;
  @Input() subTasks: any = [];
  @Output() scrollRequest = new EventEmitter<HTMLElement>();
  @Output() goToActivitiesEvent = new EventEmitter<any>();
  @Output() estimateNameChange = new EventEmitter<string>();
  @Output() isUpdateChange = new EventEmitter<boolean>();


  controlDescriptions!: { [key: string]: string; };

  controlOrder: string[] = [
    'nameCtrl',
    'radioCtrl',
    'wbsProjectCtrl',
    'wbsPreSaleCtrl',
    'salesforceNumCtrl',
    'critQuestion1Ctrl',
    'critQuestion2Ctrl',
    'projectCtrl',
    'technologyCtrl',
    'costCenterCtrl',
    'projectTypeCtrl',
    'configurationCtrl',
    'parametersCtrl',
    'macroTypeCtrl',
    'macroCtrl'
  ];

  invalidFields = {
    'name': false,
    'critQuestion1': false,
    'critQuestion2': false,
    'project': false,
    'catalog': false,
    'projectMethodology': false,
    'agileModels': false,
    'technology': false,
    'projectType': false,
    'configuration': false,
    'parameters': false,
    'macroType': false,
    'macro': false
  };

  fieldsErrorMessages = {
    'name': '',
    'critQuestion1': '',
    'critQuestion2': '',
    'project': '',
    'catalog': '',
    'projectMethodology': '',
    'agileModels': '',
    'technology': '',
    'projectType': '',
    'configuration': '',
    'parameters': '',
    'macroType': '',
    'macro': ''
  };

  variables: any;
  project: any;
  originalSubTasks: any = [];
  estimatesOnProj: any = [];
  selectedProject: any;
  allProjects: any;
  estimateCode: any;
  finalNum: any = 0;
  showNames: any = [];
  index: any;
  sessionId: string = "";
  sessionName: string = "";
  isCatalogSelected: boolean = false;
  projNameFromProjPage: any = '';
  cameFromProjPage: boolean = false;
  isProjectDropdownDisabled: boolean = false;
  metodologyTypes: any = [];
  estimateModelTypes: any = [];
  isServiceCatalog: boolean = false;
  showAddTeamMember: boolean = false;
  subTasksAiWarning: boolean = false;
  showAiMacroWarning: boolean = false;
  modifiedSubTasks: any [] = [];

  currentSelectedCatalog: any;
  filteredTasks: any = [];

  errorMessages: any;

  creator: String = '';

  /*
    List of elements from the HTML Page. They are used to calculate each section height, so we can implement smooth scrool trough each section.
  */
  @ViewChild('technologySection')
  technologyElement!: ElementRef;
  @ViewChild('projectTypeSection')
  projectTypeElement!: ElementRef;
  @ViewChild('projectRiskSection')
  projectRiskElement!: ElementRef;
  @ViewChild('riskInput') riskInput!: ElementRef<HTMLInputElement>;
  @ViewChild('configurationSection')
  configurationElement!: ElementRef;
  @ViewChild('parametersSection')
  parameterElement!: ElementRef;
  @ViewChild('macroSection')
  macroElement!: ElementRef;
  @ViewChild('riskSection')
  riskElement!: ElementRef;
  /*
    Off set to be calculated for each html section.
  */
  public techOffset: number = 0;
  public ptOffset: number = 0;
  public docOffset: number = 0;
  public configOffset: number = 0;
  public paramOffset: number = 0;
  public macroOffset: number = 0;
  public riskOffset: number = 0;
  public teamOffset: number = 0;
  //Indicates which section is current active.
  currentActive: number = 1;

  /*
    Removed currentPhase - now managed by parent EstimativaComponent.
  */
  // Flag to check if the estimate is new or is being updated
  isUpdate = false;

  // List of action items - now received via @Input from parent
  // subTasks: any = []
  //List of all projects currently in the DB.
  projects: any = []
  //List of all the technologies configured in the Backoffice.
  technologies: any = []
  /*
    Each list represents a section with possibles values. The technology holds most of the lists,
  so when the user select the technology all the followwing lists will be updated
  */
  projectTypes: any = []
  projectRisks: any;
  configurations: any = []
  parameters: any = []
  macroActivities: any = []
  filteredMacros: any = []  // Holds macros for the selected methodology
  macrosTypes: any = []
  macrosNames: any = [];
  techId: any;

  selectedProjectType: any;

  // Reactive Form
  estimativaForm: any;
  isCheckboxTouched = false;

  //If the estimate is being updated, it will hold the estimate id and the original project
  estimateId: string | undefined;
  idEstimate: string = '';
  originalProject: any;
  //Estimate object - now received via @Input from parent
  // estimate: any; (moved to @Input at top)
  //Technology selected, it will be passed to phase 2 - Activities
  technology: any;

  editedBy: EditedBy[] = [];

  reviews: Review[] = [];

  //valueDropdown
  preSale: boolean = false;
  evolProject: boolean = false;
  draft: boolean = false;

  estimateTypeLine: any;

  showRisk: boolean = false;
  private pendingAutoAiRegenerateOnReload: boolean = false;
  private pendingAiRegenerateSelection: { methodology: string; estimationModel: string } | null = null;

  filteredProjects: any[] = [];
  filteredCatalogs: any[] = [];

  crit1Options: any[] = [];


  costCenter: any[] = [];
  filteredCostCenters: any[] = [];

  costCentersGcms: any[] = [];
  availableProfiles: any[] = [];

  initialEstimate: any = [];
  createdDate: any;

  originalMetodology: string = '';
  originalMode: string = '';
  catalogProjectTypesMap: Map<string, any> = new Map();
  newMember!: FormGroup;


  isLoadingProjects: boolean = true;
  isLoadingCatalogs: boolean = true;
  isLoadingCatalog: boolean = false;
  isLoadingSelectedcatalog: boolean = true;
  isLoadingEstimate: boolean = false;
  errorDetected: boolean = false;
  errorText: string = '';

  constructor(
    private fb: FormBuilder,
    private projectsService: ProjectsService,
    private dataService: DataService,
    private dialog: MatDialog,
    private estimativaService: ApiEstimativaService,
    private projectService: ProjectsService,
    private catalogService: CatalogService,
    private router: Router,
    private usersManagementService: UsersManagementService,
    private infoBar: InfoBarWithStatusService,
    private languageService: LanguageService,
    private GCMService: GCMService,
    public authService: AuthService,
    private profileService: ProfileService,
    private notificationsService: NotificationsService  
  ) {
    this.estimativaForm = this.fb.group({
      nameCtrl: new FormControl('', Validators.required),
      critQuestion1Ctrl: new FormControl('', Validators.required),
      critQuestion2Ctrl: new FormControl('', Validators.required),
      projectCtrl: new FormControl('', Validators.required),
      projectFilterCtrl: new FormControl(),
      catalogCtrl: new FormControl('', Validators.required),
      catalogFilterCtrl: new FormControl(),
      metodologyProjectCtrl: new FormControl('', Validators.required),
      estimateModelCtrl: new FormControl(''),

      projectTypeCtrl: new FormControl('', Validators.required),
      projectRiskCtrl: new FormControl(''),// add macro checkboxes dynamically

    })
  }

  public estimationState = EstimationState;

  private readonly EDITABLE_STATES: EstimationState[] = [
    EstimationState.INCOMPLETE,
    EstimationState.COMPLETE,
    EstimationState.TO_FIX,
  ];

  get isReadOnly(): boolean {
    return !!this.estimate?.state && !this.EDITABLE_STATES.includes(this.estimate.state);
  }

  private applyReadOnlyMode(): void {
    if (this.isReadOnly) {
      this.estimativaForm.disable();
    } else {
      this.estimativaForm.enable();
    }
  }

  /*   goToEstimatate(){
      this.currentPhase = 2;
    } */


  // SMOOTH SCROLL FUNCTIONALITY
  @HostListener('window:scroll')
  checkOffsetTop() {
    // Removed currentPhase === 1 check - this component only shows phase 1 content now
    const windowHeight = window.innerHeight;
    const offset = windowHeight > 1200 ? 450 : 350;

    this.techOffset = this.technologyElement.nativeElement.getBoundingClientRect().top + window.scrollY - offset;
    this.ptOffset = this.projectTypeElement.nativeElement.getBoundingClientRect().top + window.scrollY - offset;
    this.configOffset = this.configurationElement.nativeElement.getBoundingClientRect().top + window.scrollY - offset;
    this.paramOffset = this.parameterElement?.nativeElement.getBoundingClientRect().top + window.scrollY - offset;
    this.macroOffset = this.macroElement.nativeElement.getBoundingClientRect().top + window.scrollY - offset;

    this.riskOffset = this.riskElement.nativeElement.getBoundingClientRect().top + window.scrollY - offset;

    this.paramOffset = !this.paramOffset ? this.macroOffset : this.paramOffset;

    if (window.pageYOffset >= this.techOffset && window.pageYOffset < this.ptOffset) {
      this.currentActive = 1;
    } else if (window.pageYOffset >= this.ptOffset && window.pageYOffset < this.configOffset) {
      this.currentActive = 3;
    } else if (window.pageYOffset >= this.configOffset && window.pageYOffset < this.paramOffset) {
      this.currentActive = 5;
    } else if (window.pageYOffset >= this.paramOffset && window.pageYOffset < this.macroOffset) {
      this.currentActive = 6;
    } else if (window.pageYOffset >= this.macroOffset && window.pageYOffset < this.riskOffset) {
      this.currentActive = 7;
    } else if (window.pageYOffset >= this.macroOffset && window.pageYOffset < this.teamOffset) {
      this.currentActive = 8;
    } else if (window.pageYOffset >= this.macroOffset) {
      this.currentActive = 10;
    } else {
      this.currentActive = 1;
    }
  }

  // Call this method when the button is clicked.
  scrollToTarget(target: HTMLElement, index: number): void {
    this.scrollRequest.emit(target);
    this.currentActive = index;
  }

  // Smooth Scroll
  goToSection(element: any, index: number) {
    const y = element.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: y, behavior: 'smooth' });
    this.currentActive = index;
  }

  ngOnInit(): void {

    this.pendingAutoAiRegenerateOnReload = this.dataService.consumeAiAutoRegenerateOnReloadRequest();
    if (this.pendingAutoAiRegenerateOnReload) {
      this.pendingAiRegenerateSelection = this.dataService.consumeAiAutoRegenerateSelection();
    }

    this.projNameFromProjPage = (localStorage.getItem('projName') || '').trim();
    this.cameFromProjPage = this.projNameFromProjPage.length > 0;

    this.showAiMacroWarning = this.dataService.getShowAiMacroWarning();
    this.modifiedSubTasks = this.dataService.getAiModifiedActionItems();

    if (this.dataService.getEstimate().length > 0) {
      this.isUpdate = true;
    }
    else {
      this.isUpdate = false;
    }

    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
      this.crit1Options = [
        { name: 'N.A', value: 0.1 },
        { name: this.variables.low, value: 0.25 },
        { name: this.variables.medium, value: 0.7 },
        { name: this.variables.high, value: 1 }
      ];
      // this.metodologyTypes = [{ name: "Agile", id: "agile" }, { name: this.variables.other, id: "other" }]
      this.metodologyTypes = [];
      this.estimateModelTypes = [{ name: this.variables.effortPerComplexity, id: "complex" }, { name: this.variables.tshirtSizes, id: "tshirt" }];
      this.errorMessages = getEstimationErrorMessages(this.variables);
    });

    this.getAllProjects();
    this.getAllCatalogs();

    // Only load from database if we don't have estimate data from parent
    // (estimate input comes from parent when returning from activities with modifications)
    if (this.isUpdate && !this.estimate) {
      this.getEstimateById();
      this.isUpdateChange.emit(true);
    }

    this.authService.userDataLoaded$.pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this.authService.getUserData().pipe(take(1)))
    ).subscribe(data => {
      this.creator = data.id;
    });

    // Subscribe to name control changes and emit to parent
    this.estimativaForm.get('nameCtrl')?.valueChanges.subscribe((name: string) => {
      this.estimateNameChange.emit(name);
    });

    // Load available profiles once on init
    this.profileService.getAllProfiles().subscribe({
      next: (profiles: any[]) => {
        this.availableProfiles = profiles || [];
      },
      error: (err) => {
        console.error('Error loading profiles:', err);
      }
    });

  }

  private autoSelectSingleProject(projectList: any[]) {
    if (projectList.length !== 1) {
      return;
    }

    const projectCtrl = this.estimativaForm.get('projectCtrl');
    if (!projectCtrl?.value) {
      projectCtrl?.setValue(projectList[0].id);
    }
  }

  getAllProjects() {
    this.isLoadingProjects = true;

    this.projectService.getActiveProjects().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        //const message = this.errorMessageAllTechs[err.error.message]
        //this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          if (this.cameFromProjPage) {
            const selectedProjectName = this.projNameFromProjPage.toLowerCase();
            const filteredByName = data.filter((project: any) =>
              (project?.name || '').toLowerCase() === selectedProjectName
            );

            this.projects = filteredByName;
            this.filteredProjects = filteredByName;
            this.isProjectDropdownDisabled = filteredByName.length > 0;
            this.autoSelectSingleProject(filteredByName);

            localStorage.removeItem('projName');
            this.cameFromProjPage = false;
            this.projNameFromProjPage = '';
          }
          else {
            this.filteredProjects = data;
            this.projects = data;
            this.isProjectDropdownDisabled = false;
            this.autoSelectSingleProject(data);
          }
        } catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.filteredProjects && !this.errorDetected) {
          this.isLoadingProjects = false;
        }
      }
    });
  }

  getAllCatalogs() {
    this.isLoadingCatalogs = true;

    this.catalogService.getAllCatalogs().pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        //const message = this.errorMessageAllTechs[err.error.message]
        //this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any[]) => {
        try {
          data = data.filter(catalog => catalog.active);
          this.technologies = data;
          this.filteredCatalogs = data;

          if (!this.isUpdate) {
            let currentUser: any;
            //for each catalog, get the users to determine if the current user is included
            this.authService.getUserData().subscribe(userData => {
              currentUser = userData
              if (currentUser.role != 'SUPER-ADMIN') {
                this.technologies = [];
                this.filteredCatalogs = [];

                const addCatalogIfMissing = (catalogItem: any) => {
                  const alreadyIncluded = this.technologies.some((item: any) => item.id === catalogItem.id);
                  if (!alreadyIncluded) {
                    this.technologies.push(catalogItem);
                    this.filteredCatalogs.push(catalogItem);
                  }
                };

                data.forEach((catalog: any) => {
                  this.catalogService.getUsersFromCatalogId(catalog.id).subscribe({
                    next: (users: any[]) => {
                      const emails = users.map(user => user.email);
                      if (emails.includes(currentUser.email)) {
                        addCatalogIfMissing(catalog);
                      }
                    }
                  });
                  //check if the usr is also the owner of the catalog
                  this.catalogService.getCatalogById(catalog.id).subscribe({
                    next: (catalogDetails: any) => {
                      if (catalogDetails.owner === currentUser) {
                        addCatalogIfMissing(catalog);
                      }
                    }
                  });   
                });
              }
            })
          }
        }
        catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.filteredCatalogs && !this.errorDetected) {
          this.isLoadingCatalogs = false;

          // After catalogs are loaded, restore form if coming back from phase 2
          if (this.estimate && this.estimate.catalog) {
            this.setForm(this.estimate);
            this.applyReadOnlyMode();
          }
        }
      }
    });
  }

  getCatalogById(catalogId: string, estimate?: any) {

    this.isLoadingCatalog = true;

    this.catalogService.getCatalogById(catalogId).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        //const message = this.errorMessageAllTechs[err.error.message]
        //this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.projectTypes = data.projectTypes;
          this.configurations = data.configurations;
          this.parameters = data.parameters;
          this.macroActivities = data.macroActivities;
          const aiMacros = this.dataService.getAiGeneratedMacros();
          if (aiMacros != undefined && aiMacros != null) {
            
            if (this.estimate != null && aiMacros.estimateId == this.estimate?.id 
              || (this.estimate == null && this.estimativaForm.get('nameCtrl')?.value == aiMacros.estimateName)) {
              const macro = this.macroActivities.filter((m: any) => m.metodology.toLowerCase() == aiMacros.methodology.toLowerCase())
              macro.forEach((m:any) => {
                m.macroActivities = [...m.macroActivities, ...aiMacros.macros];
              });
            }
          }
          this.techId = data.technologyId

          this.getMetodologyTypesToDropDown(this.macroActivities);

          // Use estimate data if provided, regardless of isUpdate status
          if (estimate) {
            this.createProjectTypeCtrl(estimate);
            this.createConfigurationsCtrl(estimate);
            this.createParametersCtrl(estimate);
            this.createMacrosCtrl(estimate);
          }
          else {
            this.createProjectTypeCtrl();
            this.createConfigurationsCtrl();
            this.createParametersCtrl();
            //if (this.isUpdate) {
              this.createMacrosCtrl();
            //}
          }
        } catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.projectTypes && this.configurations && this.parameters && this.macroActivities && !this.errorDetected) {
          this.isLoadingCatalog = false;
          this.tryAutoGenerateAfterReload();
        }
      }
    });
  }

  getEstimateById() {
    this.isLoadingEstimate = true;
    this.estimativaService.getEstimateById(this.dataService.getEstimate()).pipe(
      retryWhen(errors =>
        errors.pipe(
          scan((retryCount, error) => {
            if (retryCount >= 3) {
              throw error;
            }
            return retryCount + 1;
          }, 0),
          delay(2500)
        )
      ),
      catchError(err => {
        console.error('Error:', err);

        this.errorDetected = true;
        //const message = this.errorMessageAllTechs[err.error.message]
        //this.errorText = message ? message : this.variables.detectedError;

        return throwError(() => err);
      })
    ).subscribe({
      next: (data: any) => {
        try {
          this.estimate = data;
          this.originalSubTasks = this.estimate.subTasks
          this.setForm(data);
          // this.updateForm(data);
          //this.createMacrosCtrl();

          //this.technologies = data;
        } catch (err) {
          console.error('Error:', err);

          this.errorDetected = true;
          this.errorText = this.variables.detectedError;
        }
      },
      complete: () => {
        if (this.estimate && !this.errorDetected) {
          this.isLoadingEstimate = false;
        }
      }
    });
  }

  createProjectTypeCtrl(estimate?: any) {
    // Store catalog project types for comparison
    this.catalogProjectTypesMap.clear();
    this.projectTypes.forEach((pt: any) => {
      this.catalogProjectTypesMap.set(pt.name, { name: pt.name, risk: pt.risk });
    });

    // Build the list of project types to display, handling estimate modifications
    let projectTypesToDisplay = [...this.projectTypes];

    if (estimate && estimate.projectType) {
      const estimateProjectType = estimate.projectType;

      // Check if a project type with the same name exists in catalog
      const catalogIndex = projectTypesToDisplay.findIndex((pt: any) =>
        pt.name === estimateProjectType.name
      );

      if (catalogIndex !== -1) {
        // Same name exists in catalog
        if (projectTypesToDisplay[catalogIndex].risk !== estimateProjectType.risk) {
          // Different risk: replace catalog entry with estimate entry (mark as modified)
          projectTypesToDisplay[catalogIndex] = {
            name: estimateProjectType.name,
            risk: estimateProjectType.risk,
            styleField: 'colorGray',
            selected: true
          };
        } else {
          // Same risk: just mark as selected
          projectTypesToDisplay[catalogIndex].selected = true;
        }
      } else {
        // Completely different name: add as new entry
        projectTypesToDisplay.push({
          name: estimateProjectType.name,
          risk: estimateProjectType.risk,
          styleField: 'colorGray',
          selected: true
        });
      }
    }

    const projectTypeFormArray = new FormArray(
      projectTypesToDisplay.map((item: any) =>
        new FormGroup({
          name: new FormControl(item.name),
          risk: new FormControl(item.risk),
          selected: new FormControl(item.selected || false),
          styleField: new FormControl(item.styleField || null)
        })
      )
    );

    projectTypeFormArray.setValidators([
      (control: AbstractControl) => {
        const formArray = control as FormArray;
        const atLeastOneChecked = formArray.controls.some(group => group.get('selected')?.value);
        return atLeastOneChecked ? null : { atLeastOneChecked: true };
      }
    ]);

    this.estimativaForm.setControl('projectTypeCtrl', projectTypeFormArray);
  }

  createConfigurationsCtrl(estimate?: any) {
    const configurationFormArray = new FormArray(
      this.configurations.map((item: any) =>
        new FormGroup({
          name: new FormControl(item.name),
          complexity: new FormControl(item.complexity),
          selected: new FormControl(item.checked || false),
          profileId: new FormControl(item.profileId || null)
        })
      )
    );

    // configurationFormArray.setValidators([
    //   (control: AbstractControl) => {
    //     const formArray = control as FormArray;
    //     const atLeastOneChecked = formArray.controls.some(group => group.get('selected')?.value);
    //     return atLeastOneChecked ? null : { atLeastOneChecked: true };
    //   }
    // ]);

    if (estimate) {
      estimate.configurations.forEach((config: any) => {
        const existingConfigGroup = configurationFormArray.controls.find((group: any) =>
          group.get('name')?.value == config.name &&
          group.get('complexity')?.value == config.complexity
        );

        if (existingConfigGroup) {
          existingConfigGroup.get('selected')?.setValue(true);
          existingConfigGroup.get('complexity')?.setValue(config.complexity);
          existingConfigGroup.get('profileId')?.setValue(config.profileId || null);
        }
        else {
          const newGroup = new FormGroup({
            name: new FormControl(config.name),
            complexity: new FormControl(config.complexity),
            selected: new FormControl(true),
            profileId: new FormControl(config.profileId || null)
          });
          configurationFormArray.push(newGroup);

          this.configurations.push({
            name: config.name,
            complexity: config.complexity,
            styleField: 'colorGray'
          });
        }
      });
    }

    this.estimativaForm.setControl('configurationCtrl', configurationFormArray);
  }

  createParametersCtrl(estimate?: any) {
    const parametersFormArray = new FormArray(
      this.parameters.map((item: any) =>
        new FormGroup({
          name: new FormControl(item.name),
          complexity: new FormControl(item.complexity),
          selected: new FormControl(item.checked || false),
          profileId: new FormControl(item.profileId || null)
        })
      )
    );

    if (estimate) {
      estimate?.parameters.forEach((param: any) => {
        const paramGroup = parametersFormArray.controls.find((group: any) =>
          group.get('name')?.value == param.name &&
          group.get('complexity')?.value == param.complexity
        );

        if (paramGroup) {
          paramGroup.get('selected')?.setValue(true);
          paramGroup.get('complexity')?.setValue(param.complexity);
          paramGroup.get('profileId')?.setValue(param.profileId || null);
        }
        else {
          const newGroup = new FormGroup({
            name: new FormControl(param.name),
            complexity: new FormControl(param.complexity),
            selected: new FormControl(true),
            profileId: new FormControl(param.profileId || null)
          });
          parametersFormArray.push(newGroup);

          this.parameters.push({
            name: param.name,
            complexity: param.complexity,
            styleField: 'colorGray'
          });
        }
      });
    }

    this.estimativaForm.setControl('parametersCtrl', parametersFormArray);
  }

  createMacrosCtrl(estimate?: any) {
    const methodology = this.estimativaForm.value.metodologyProjectCtrl;

    if (!methodology) {
      this.filteredMacros = [];
      this.estimativaForm.setControl('macroTypeCtrl', new FormArray([]));
      return;
    }

    // Find the methodology group
    const macroTempArray = this.macroActivities.find((item: any) => item.metodology.toLowerCase() === methodology.toLowerCase());

    if (!macroTempArray) {
      console.error('No macro activities found for methodology:', methodology);
      this.estimativaForm.setControl('macroTypeCtrl', new FormArray([]));
      return;
    }

    const seenMacroNames = new Set<string>();
    const uniqueMacroActivities = (macroTempArray.macroActivities || []).filter((item: any) => {
      const macroName = (item?.name || '').toString().trim().toLowerCase();
      if (!macroName || seenMacroNames.has(macroName)) {
        return false;
      }
      seenMacroNames.add(macroName);
      return true;
    });

    // Store filtered macros for template display
    this.filteredMacros = uniqueMacroActivities;

    // Create flat FormArray with just macros
    const macroTypeFormArray = new FormArray(
      uniqueMacroActivities.map((item: any) => {
        return new FormGroup({
          name: new FormControl(item.name),
          effort: new FormControl(item.effort),
          selected: new FormControl(item.checked || false),
          styleField: new FormControl(item.styleField || null),
          profileId: new FormControl(item.profileId || null),
          maxHours: new FormControl(item.maxHours || null),
          aiGenerated: new FormControl(item.aiGenerated || null)
        });
      })
    );

    // Simplified validator for flat structure
    macroTypeFormArray.setValidators([
      control => {
        const atLeastOneMacro = macroTypeFormArray.controls.some(macro =>
          macro.get('selected')?.value
        );
        return atLeastOneMacro ? null : { macroRequired: true };
      }
    ]);

    // Handle estimate updates - merge saved macros with current list
    if (estimate && estimate.macroActivities) {
      estimate.macroActivities.forEach((savedMacroGroup: any) => {
        // Only process if it matches the current methodology
        if (savedMacroGroup.metodology.toLowerCase() === methodology.toLowerCase()) {
          savedMacroGroup.macroActivities.forEach((savedMacro: any) => {
            // Find existing macro in form array
            const existingMacroIndex = macroTypeFormArray.controls.findIndex((m: any) =>
              m.get('name')?.value === savedMacro.name
            );

            if (existingMacroIndex !== -1) {
              // Update existing macro
              const existingMacro = macroTypeFormArray.at(existingMacroIndex) as FormGroup;
              existingMacro.patchValue({
                selected: true,
                effort: savedMacro.effort,
                profileId: savedMacro.profileId || null,
                maxHours: savedMacro.maxHours || null,
                aiGenerated: existingMacro.get('aiGenerated')?.value || false
              });
              // Also add to filteredMacros for display
              this.filteredMacros.push({
                name: savedMacro.name,
                effort: savedMacro.effort,
                checked: true,
                styleField: 'colorGray',
                profileId: savedMacro.profileId || null,
                maxHours: savedMacro.maxHours || null,
                aiGenerated: existingMacro.get('aiGenerated')?.value || false
              });
            } else {
              // Add macro not in catalog (shown in gray)
              macroTypeFormArray.push(new FormGroup({
                name: new FormControl(savedMacro.name),
                effort: new FormControl(savedMacro.effort),
                selected: new FormControl(true),
                styleField: new FormControl('colorGray'),
                profileId: new FormControl(savedMacro.profileId || null),
                maxHours: new FormControl(savedMacro.maxHours || null),
                aiGenerated: new FormControl(savedMacro.aiGenerated || false)
              }));
              // Also add to filteredMacros for display
              this.filteredMacros.push({
                name: savedMacro.name,
                effort: savedMacro.effort,
                checked: true,
                styleField: 'colorGray',
                profileId: savedMacro.profileId || null,
                maxHours: savedMacro.maxHours || null,
                aiGenerated: false
              });
            }
          });
        }
      });
    }

    //sort filteredMacros by aiGenerate = true first
    this.filteredMacros.sort((a:any, b:any) => {
      if (a.aiGenerated && !b.aiGenerated) return -1;
      if (!a.aiGenerated && b.aiGenerated) return 1;
      return 0;
    });

    this.estimativaForm.setControl('macroTypeCtrl', macroTypeFormArray);

  }

    /**
     * Returns true if there is a selected macro in the display (filteredMacros)
     * that is an existing macro (not newly generated in this session) and has aiGenerated=true.
     */
    private shouldShowInitialAiMacroWarning(): boolean {
      if (!Array.isArray(this.filteredMacros)) return false;
      // Show warning if any selected macro is aiGenerated and not just added in this session
      return this.filteredMacros.some((macro: any) => macro.checked && macro.aiGenerated === true);
    }

    // Track if the warning has been displayed in this session
    private hasDisplayedAiMacroWarning = false;

    getProfileNameForDisplay(profileId: string | null): string {
    if (!profileId) {
      return '';
    }
    const profile = this.availableProfiles.find(p => p.id === profileId);
    if (!profile) {
      return '';
    }
    const costPerHour = profile.costPerHour ? `${profile.costPerHour}€/h` : '0€/h';
    return `${profile.center} - ${profile.name} - ${costPerHour}`;
  }

  openProfileDialog(index: number, ctrl: string): void {
    const formArray = this.estimativaForm.get(ctrl) as FormArray;
    
    if (!formArray || index >= formArray.length) {
      console.error('Invalid index');
      return;
    }

    const group = formArray.at(index) as FormGroup;
    const currentProfileId = group.get('profileId')?.value || null;
    const name = group.get('name')?.value;

    // Fetch all available profiles
    this.profileService.getAllProfiles().subscribe({
      next: (profiles: any[]) => {
        // Get the current profile name if profile exists
        const currentProfile = profiles.find(p => p.id === currentProfileId);
        const currentProfileName = currentProfile?.name || this.variables?.none || 'Ninguno';
        const currentProfileCenter = currentProfile?.center || this.variables?.none || 'Ninguno';
        const currentProfileCostPerHour = currentProfile?.costPerHour || this.variables?.none || 'Ninguno';

        const dialogRef = this.dialog.open(ProfileSelectorDialogComponent, {
          width: '40vw',
          data: {
            profileId: currentProfileId,
            profiles: profiles,
            name: name,
            currentProfileCenter: currentProfileCenter,
            currentProfileCostPerHour: currentProfileCostPerHour,
            currentProfileName: currentProfileName
          }
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          if (result && result.profileId !== undefined) {
            // Update the profileId in the form
            group.patchValue({
              profileId: result.profileId
            });
          }
        });
      },
      error: (err) => {
        console.error('Error loading profiles:', err);
        this.infoBar.showSnackbar(
          this.variables?.errorLoadingProfiles || 'Error al cargar los perfiles',
          ['error-snackbar'],
          3000
        );
      }
    });
  }


  /** True once Catalog, Methodology and (for agile) Estimation model are selected. */
  get showAiSection(): boolean {
    const catalogValue = this.estimativaForm.get('catalogCtrl')?.value;
    const metodologyValue = this.estimativaForm.get('metodologyProjectCtrl')?.value;
    const estimationModelValue = this.estimativaForm.get('estimateModelCtrl')?.value;

    if (metodologyValue?.toLowerCase() === 'agile') {
      return !!catalogValue && !!metodologyValue && !!estimationModelValue;
    }
    return !!catalogValue && !!metodologyValue;
  }

  get hasPendingAiGeneratedData(): boolean {
    return this.hasExistingAiGeneratedData();
  }

  openAiGenerateDialog(): void {
    if (this.hasExistingAiGeneratedData()) {
      const dialogRef = this.dialog.open(GenericDialogComponent, {
        data: {
          message: this.variables?.aiRegenerateWarning || 'Las macro-actividades y subtareas generadas por IA que ya existen se eliminarán y se reemplazarán por unas nuevas. Se perderán los datos de IA no guardados. ¿Desea continuar?'
        }
      });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result?.data) {
          this.showAiMacroWarning = false;
          this.hasDisplayedAiMacroWarning = false;
          this.dataService.clearShowAiMacroWarning();

          this.removeALLAiReferences();

          if (this.isUpdate)
            this.reloadPageWithOriginalData();
          else
            this.openAiGenerateDialogInternal();

        }
        else
          return;
      });

    }
    else
      this.openAiGenerateDialogInternal();
  }

  private openAiGenerateDialogInternal(): void {
    const estimateNameValue = this.estimativaForm.get('nameCtrl')?.value;
    const catalogId = this.estimativaForm.get('catalogCtrl')?.value;
    const methodology = this.estimativaForm.get('metodologyProjectCtrl')?.value;
    const estimationModel = this.estimativaForm.get('estimateModelCtrl')?.value || '';

    const dialogRef = this.dialog.open(AiGenerateDialogComponent, {
      width: '500px',
      disableClose: true,
      data: { catalogId: catalogId, estimateName: estimateNameValue, estimateId: this.estimateId, methodology: methodology, estimationModel: estimationModel }
    });

    dialogRef.afterClosed().subscribe((result: { macroActivities: any[]; actionItems: any[] } | null) => {
      if (result) {
        this.applyAiResults(result);
      }
    });
  }

  private hasExistingAiGeneratedData(): boolean {
    const macroFormArray = this.estimativaForm.get('macroTypeCtrl') as FormArray;

    return hasAiGeneratedSubTasks(this.estimate?.subTasks)
      || hasAiGeneratedSubTasks(this.subTasks)
      || hasAiGeneratedSubTasks(this.originalSubTasks)
      || hasAiGeneratedMacros(this.estimate?.macroActivities)
      || hasAiGeneratedMacros(this.macroActivities)
      || hasAiGeneratedMacros(this.filteredMacros)
      || hasAiGeneratedMacrosInForm(macroFormArray?.controls);
  }

  private clearAiData() {
    this.dataService.clearAiGeneratedMacros();
    this.dataService.clearAiGeneratedActionItems();
    this.dataService.clearShowAiMacroWarning();
    this.dataService.clearAiModifieddActionItems();
  }

  private removeAiGeneratedMacrosFromForm(): void {
    const removeAiItems = (items: any[]): any[] => {
      if (!Array.isArray(items)) {
        return items;
      }

      return items.filter((item: any) => !isAiGeneratedItem(item));
    };

    const macroFormArray = this.estimativaForm.get('macroTypeCtrl') as FormArray;

    if (macroFormArray) {
      macroFormArray.controls.forEach((group: AbstractControl) => {
        if (group.get('aiGenerated')?.value === true) {
          group.patchValue({ selected: false, aiGenerated: false }, { emitEvent: false });
        }
      });
    }

    this.filteredMacros = this.filteredMacros.map((macro: any) =>
      isAiGeneratedItem(macro) ? { ...macro, aiGenerated: false, checked: macro.checked } : macro
    );

    this.macroActivities = this.macroActivities.map((group: any) => {
      if (Array.isArray(group?.macroActivities)) {
        group.macroActivities = group.macroActivities.map((macro: any) =>
          isAiGeneratedItem(macro) ? { ...macro, aiGenerated: false } : macro
        );
      }
      return group;
    });

    if (this.estimate && Array.isArray(this.estimate.macroActivities)) {
      this.estimate.macroActivities = this.estimate.macroActivities.map((group: any) => {
        if (Array.isArray(group?.macroActivities)) {
          group.macroActivities = group.macroActivities.map((macro: any) =>
            isAiGeneratedItem(macro) ? { ...macro, aiGenerated: false } : macro
          );
        }
        return group;
      });
    }

    macroFormArray.updateValueAndValidity();
  }

  private removeAiGeneratedSubTasks(): void {
    const removeAiItems = (items: any[]): any[] => {
      if (!Array.isArray(items)) {
        return items;
      }

      return items.filter((item: any) => !isAiGeneratedItem(item));
    };

    this.subTasks = removeAiItems(this.subTasks);
    this.modifiedSubTasks = removeAiItems(this.modifiedSubTasks);

    if (this.estimate && Array.isArray(this.estimate.subTasks)) {
      this.estimate.subTasks = removeAiItems(this.estimate.subTasks);
    }

    const componentAsAny = this as any;
    if (Array.isArray(componentAsAny.modifiedAiSubTasks)) {
      componentAsAny.modifiedAiSubTasks = removeAiItems(componentAsAny.modifiedAiSubTasks);
    }
  }

  private reloadPageWithOriginalData(): void {
    const methodology = this.estimativaForm.get('metodologyProjectCtrl')?.value || '';
    const estimationModel = methodology?.toLowerCase() === 'agile'
      ? (this.estimativaForm.get('estimateModelCtrl')?.value || '')
      : '';

    this.removeALLAiReferences();
    if (this.isUpdate) {
      this.dataService.setAiAutoRegenerateSelection({ methodology, estimationModel });
      this.dataService.requestAiAutoRegenerateOnReload();
      window.location.reload();
    }
  }
  
  private tryAutoGenerateAfterReload(): void {
    if (!this.pendingAutoAiRegenerateOnReload) {
      return;
    }

    this.pendingAutoAiRegenerateOnReload = false;

    const filePath = this.dataService.getLastAiFunctionalFilePath();
    const estimateNameValue = this.estimativaForm.get('nameCtrl')?.value;
    const catalogId = this.estimativaForm.get('catalogCtrl')?.value;
    const methodology = this.pendingAiRegenerateSelection?.methodology || this.estimativaForm.get('metodologyProjectCtrl')?.value;
    const estimationModel = (methodology?.toLowerCase() === 'agile')
      ? (this.pendingAiRegenerateSelection?.estimationModel || this.estimativaForm.get('estimateModelCtrl')?.value || '')
      : '';

    if (methodology) {
      this.estimativaForm.patchValue({
        metodologyProjectCtrl: methodology,
        estimateModelCtrl: estimationModel
      }, { emitEvent: false });
      this.createMacrosCtrl(this.estimate);
    }

    this.pendingAiRegenerateSelection = null;
    this.dataService.clearAiAutoRegenerateSelection();

    if (!filePath || !catalogId || !methodology || !estimateNameValue) {
      this.infoBar.showSnackbar(
        this.variables?.aiGenerateError || 'Erro ao gerar atividades. Por favor, tente novamente.',
        ['error-snackbar'],
        4000
      );
      return;
    }

    const payload = {
      catalogId: catalogId,
      estimateId: this.estimate?.id || this.estimateId,
      estimateName: estimateNameValue,
      methodology: methodology,
      estimationModel: estimationModel,
      filePath: filePath
    };

    this.infoBar.showSnackbar(
      this.variables?.generatingActivities || 'Generando actividades...',
      ['successful-snackbar'],
      2500
    );

    this.estimativaService.generateActivities(payload).subscribe({
      next: (result: any) => {
        if (result) {
          this.applyAiResults(result);
        }
      },
      error: (error) => {
        this.infoBar.showSnackbar(
          error?.error?.message || this.variables?.aiGenerateError || 'Erro ao gerar atividades. Por favor, tente novamente.',
          ['error-snackbar'],
          4000
        );
      }
    });
  }

  private applyAiResults(result: { macroActivities: any[]; actionItems: any[] }): void {

    // --- Apply macro-activity selections ---

    this.dataService.setAiGeneratedMacros({ 'estimateId': this.estimate == null? null : this.estimate.id, 'estimateName': this.estimativaForm.get('nameCtrl')?.value, 'methodology': this.estimativaForm.get('metodologyProjectCtrl')?.value, 'macros': result.macroActivities.filter((m:any) => m.aiGenerated === true)});

    const macroFormArray = this.estimativaForm.get('macroTypeCtrl') as any;
    if (macroFormArray && result.macroActivities && result.macroActivities.length > 0) {
      macroFormArray.controls.forEach((group: any) => {
        const macroName = group.get('name')?.value;
        const aiMacro = result.macroActivities.find((m: any) => m.name === macroName);
        if (aiMacro) {
          group.patchValue({ selected: true, aiGenerated: true, profileId: aiMacro.profileId || null, maxHours: aiMacro.maxHours || null, effort: aiMacro.effort });
          // Reflect on filteredMacros for template display
          const fm = this.filteredMacros.find((m: any) => m.name === macroName);
          if (fm) {
            fm.aiGenerated = true;
            fm.checked = true;
          }
        } else if (group.get('aiGenerated')?.value === true) {
          group.patchValue({ selected: false, aiGenerated: false });
          const fm = this.filteredMacros.find((m: any) => m.name === macroName);
          if (fm) {
            fm.aiGenerated = false;
            fm.checked = false;
          }
        }
      });
    }

    // Initial AI macro warning logic
    if (!this.hasDisplayedAiMacroWarning && this.shouldShowInitialAiMacroWarning()) {
      this.showAiMacroWarning = true;
      this.hasDisplayedAiMacroWarning = true;
      this.dataService.setShowAiMacroWarning(true);
    }

    
    // --- Store AI action items to carry forward ---

    this.dataService.setAiGeneratedActionItems({ 'estimateId': this.estimate == null? null : this.estimate.id, 'estimateName': this.estimativaForm.get('nameCtrl')?.value, 'methodology':  this.estimativaForm.get('metodologyProjectCtrl')?.value, 'actionItems': result.actionItems.filter((m:any) => m.aiGenerated === true)});

    //append the generated task directly to the estimate subtasks
    if (result.actionItems && result.actionItems.length > 0) {
      // Remove duplicates: filter out AI-generated items that already exist in subTasks
      const aiGeneratedItems = result.actionItems.filter((item: any) => item.aiGenerated === true);
      if (this.estimate) {
        const oldItems = this.estimate.subTasks || [];
        const uniqueOldItems = oldItems.filter((newItem: any) => 
          !aiGeneratedItems.some((existingItem: any) => existingItem.task === newItem.task && existingItem.subTask === newItem.subTask)
        );
        const replaceOldItems = oldItems.filter((newItem: any) => 
          aiGeneratedItems.some((existingItem: any) => existingItem.task === newItem.task && existingItem.subTask === newItem.subTask)
        );
        this.subTasksAiWarning = false;
        if (oldItems.length != uniqueOldItems.length) 
          this.subTasksAiWarning = true;

        this.modifiedSubTasks = replaceOldItems;
        //this.dataService.setAiModifiedActionItems(this.modifiedSubTasks);
          
        this.estimate.subTasks = [...uniqueOldItems, ...aiGeneratedItems];
        this.subTasks = this.estimate.subTasks;
      }
      else
        this.subTasks = aiGeneratedItems;
    }

    this.infoBar.showSnackbar(
      this.variables?.aiActivitiesGenerated || 'Actividades generadas por IA. Revísalas antes de guardar.',
      ['successful-snackbar'],
      6000
    );
 }

    // Call this after macros are saved to clear the warning
    public clearAiMacroWarningAfterSave(): void {
      this.showAiMacroWarning = false;
      this.hasDisplayedAiMacroWarning = false;
    }

    setForm(estimate: any) {    this.applyReadOnlyMode();

    const methodology = this.pendingAiRegenerateSelection?.methodology || estimate.projectMetodology || '';
    const estimationModel = methodology?.toLowerCase() === 'agile'
      ? (this.pendingAiRegenerateSelection?.estimationModel || estimate.estimateMode || '')
      : '';

    this.estimativaForm.patchValue({
      nameCtrl: estimate.name || '',
      critQuestion1Ctrl: estimate.criticality?.complexity1 || '',
      critQuestion2Ctrl: estimate.criticality?.complexity2 || '',
      projectCtrl: estimate.project || '',
      catalogCtrl: estimate.catalog || '',
      metodologyProjectCtrl: methodology,
      estimateModelCtrl: estimationModel,
    }, { emitEvent: false });

    // Set original methodology and mode for validation
    this.originalMetodology = methodology;
    this.originalMode = estimationModel;

    // Emit the initial name to parent component
    this.estimateNameChange.emit(estimate.name || '');

    this.onChangeTechCatalog(estimate.catalog, estimate)

  }

  setFormCatalog(estimate?: any) {
    const projectTypeCtrlArray = this.estimativaForm.get('projectTypeCtrl') as FormArray;
    const matchedProjectType = this.projectTypes.find((pt: any) => pt.name === estimate.projectType?.name && pt.risk === estimate.projectType?.risk);
    if (matchedProjectType) {
      matchedProjectType.checked = true;
      projectTypeCtrlArray.push(new FormControl(estimate.projectType)); // This updates the `[checked]` binding
    }


    const configurationArray = this.estimativaForm.get('configurationCtrl') as FormArray;
    const parametersArray = this.estimativaForm.get('parametersCtrl') as FormArray;

    estimate.configurations.forEach((config: any) => {
      const match = this.configurations.find((c: any) => c.name === config.name && c.complexity === config.complexity);
      if (match) {
        match.checked = true;
        configurationArray.push(new FormControl(config)); // This updates the `[checked]` binding
      }
    });

    estimate.parameters && estimate.parameters.forEach((param: any) => {
      const match = this.parameters.find((c: any) => c.name === param.name && c.complexity === param.complexity);
      if (match) {
        match.checked = true;
        parametersArray.push(new FormControl(param)); // This updates the `[checked]` binding
      }
    });
  }

  onProjectTypeSelected(selectedIndex: number): void {
    const projectTypesArray = this.estimativaForm.get('projectTypeCtrl') as FormArray;

    projectTypesArray.controls.forEach((group, index) => {
      const isSelected = index === selectedIndex;
      group.get('selected')?.setValue(isSelected, { emitEvent: false });
    });
  }

  resetCatalogFrom() {
    this.estimativaForm.get('configurationCtrl')?.clear();
    this.estimativaForm.get('parametersCtrl')?.clear();
    this.estimativaForm.get('macroTypeCtrl')?.clear();
    this.estimativaForm.get('macroCtrl')?.clear();
  }

  onMetodologyChange(event: any) {
    const newValue = event.value;

    const estimateSubTasksCount = this.estimate?.subTasks?.length || 0;
    const currentSubTasksCount = this.subTasks?.length || 0;
    const hasSubTasks = estimateSubTasksCount > 0 || currentSubTasksCount > 0;

    if (hasSubTasks) {
      if (newValue !== this.originalMetodology) {
        const confirmChange = window.confirm(this.variables.confirmOnChangeMetodOrMode);

        if (!confirmChange) {
          this.estimativaForm.get('metodologyProjectCtrl').setValue(this.originalMetodology, { emitEvent: false });
          return; // Exit early if user cancels
        } else {
          if (this.estimate?.subTasks) {
            this.estimate.subTasks.length = 0;
          }
          if (this.subTasks) {
            this.subTasks.length = 0;
          }
          this.originalMetodology = newValue;
        }
      }
    }

    this.removeALLAiReferences();

    // Always recreate macro controls when methodology changes to apply the filter
    this.createMacrosCtrl(this.estimate);
  }


  disableMethodologyMacro(methodInMacros: string): boolean {
    const methodology = this.estimativaForm.value.metodologyProjectCtrl;

    if (methodology == '')
      return true;

    if (methodology.toLowerCase() == 'agile' && 'Agile' == methodInMacros) {
      return false;
    }
    else if (methodology.toLowerCase() != 'agile' && methodInMacros != 'Agile') {
      return false;
    }
    return true;
  }


  disableMethodologyMacroMessage(methodInMacros: string): string {
    const methodology = this.estimativaForm.value.metodologyProjectCtrl;

    if (methodology == '')
      return this.variables.selectMetodology;

    if (methodology.toLowerCase() == 'agile' && 'Agile' != methodInMacros) {
      return this.variables.differentMethod;
    }
    else if (methodology.toLowerCase() != 'agile' && methodInMacros.toLowerCase() == 'agile') {
      return this.variables.differentMethod;
    }

    return '';
  }

  onModeChange(event: any) {
    const newValue = event.value;
    if (this.subTasks.length != 0) {
      if (newValue !== this.originalMode) {
        const confirmChange = window.confirm(this.variables.confirmOnChangeMetodOrMode);

        if (!confirmChange) {
          this.estimativaForm.get('estimateModelCtrl').setValue(this.originalMode, { emitEvent: false });
        } else {
          if (this.estimate?.subTasks) {
            this.estimate.subTasks.length = 0;
          }
          this.subTasks = [];
          this.originalMode = newValue;
        }
      }
    }
    this.removeALLAiSubTaskReferences();
  }

  setValidatorEstimateModel() {
    this.estimativaForm.get('metodologyProjectCtrl')?.valueChanges.subscribe((value: any) => {
      let estimateModelCtrl = this.estimativaForm.get('estimateModelCtrl')
      value.toLowerCase() == 'agile' && estimateModelCtrl.setValidators(Validators.required);
      value.toLowerCase() == 'agile' && estimateModelCtrl.updateValueAndValidity();

      value.toLowerCase() != 'agile' && estimateModelCtrl.clearValidators();
      value.toLowerCase() != 'agile' && estimateModelCtrl.reset();
      value.toLowerCase() != 'agile' && estimateModelCtrl.updateValueAndValidity();
    })
  }

  filterCostCenters() {
    if (!this.costCenter) {
      return;
    }
    let search = this.estimativaForm.get('costCentersFilterCtrl').value;
    if (!search) {
      this.filteredCostCenters = (this.costCenter.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredCostCenters = this.costCenter.filter((costCenters: any) => costCenters.toLowerCase().indexOf(search) > -1);


  }


  checkInvalidControls(): string[] {
    const invalidControls: string[] = [];

    this.controlOrder.forEach(controlName => {
      const control = this.estimativaForm.get(controlName);

      if (control && control.invalid) {
        const description = this.controlDescriptions[controlName];
        invalidControls.push(description);
      }
    });

    return invalidControls;
  }

  saveEstimate() {
    if (this.isReadOnly) {
      return;
    }

    if (this.estimativaForm.status !== 'VALID') {
      return
    };

    this.cleanErrors()
    const formGroup = this.estimativaForm.value;

    let invalid = false


    if (!this.validateControls(formGroup)) {
      invalid = true;
    }

    if (!this.validateControlsExtra(formGroup)) {
      invalid = true;
    }


    if (invalid) {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 4000);
      return
    };

    if (this.estimativaForm.valid) {

      const projectType = this.estimativaForm.get('projectTypeCtrl') as FormArray;
      const selectedProjectType = projectType.controls
        .filter((group: any) => group.get('selected')?.value)
        .map((group: any) => ({
          name: group.get('name')?.value,
          risk: group.get('risk')?.value
        }));

      const configurations = this.estimativaForm.get('configurationCtrl') as FormArray;

      const selectedConfigurations = configurations.controls
        .filter((group: any) => group.get('selected')?.value)
        .map((group: any) => ({
          name: group.get('name')?.value,
          complexity: group.get('complexity')?.value,
          profileId: group.get('profileId')?.value || null
        }));

      const parameters = this.estimativaForm.get('parametersCtrl') as FormArray;
      const selectedParameters = parameters.controls
        .filter((group: any) => group.get('selected')?.value)
        .map((group: any) => ({
          name: group.get('name')?.value,
          complexity: group.get('complexity')?.value,
          profileId: group.get('profileId')?.value || null
        }));

      const macroActivities = this.estimativaForm.get('macroTypeCtrl') as FormArray;
      const methodology = this.estimativaForm.value.metodologyProjectCtrl;

      const hasAiMacros = macroActivities.controls
        .some((macro: any) => macro.get('selected')?.value && macro.get('aiGenerated')?.value == true);

      const selectedMacros = macroActivities.controls
        .filter((macro: any) => macro.get('selected')?.value)
        .map((macro: any) => ({
          name: macro.get('name')?.value,
          effort: macro.get('effort')?.value,
          profileId: macro.get('profileId')?.value || null,
          maxHours: macro.get('maxHours')?.value || null,
          aiGenerated: false
        }));

      const macroActivitiesData = selectedMacros.length > 0 ? [{
        metodology: methodology,
        macroActivities: selectedMacros
      }] : [];

      let estimate = {
        name: this.estimativaForm.get('nameCtrl')?.value,
        criticality: {
          complexity1: this.estimativaForm.get('critQuestion1Ctrl')?.value,
          complexity2: this.estimativaForm.get('critQuestion2Ctrl')?.value
        },
        project: this.estimativaForm.get('projectCtrl')?.value,
        catalog: this.estimativaForm.get('catalogCtrl')?.value,
        projectMetodology: this.estimativaForm.get('metodologyProjectCtrl')?.value,
        estimateMode: this.estimativaForm.get('metodologyProjectCtrl')?.value.toLowerCase() == "agile" ? this.estimativaForm.get('estimateModelCtrl')?.value : null,
        projectType: selectedProjectType[0],
        configurations: selectedConfigurations,
        parameters: selectedParameters,
        macroActivities: macroActivitiesData,
        // usar siempre las actividades actuales como subTasks
        subTasks: (this.originalSubTasks.length > 0 ? this.originalSubTasks : this.subTasks) || [],
        state: this.estimationState.INCOMPLETE,
        noToolsJustification: '',
        profileSnapshots: [],
        ownerId: this.creator
      }

      const hasAiActions = estimate.subTasks.some((st: any) => st.aiGenerated === true);

      estimate.subTasks = estimate.subTasks.map((item:any) => { item.aiGenerated = false; return item; })

      const hasTasks = this.originalSubTasks.length > 0 || this.subTasks.length > 0;
      const dialogMessage = hasTasks ? this.variables.howToSaveEstimate : this.variables.howToSaveOnlyAsOngoing;
      const hasTool = estimate.subTasks.some((item: any) => item.tool !== null);

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        data: {
          message: dialogMessage,
          needJustification: !hasTool,
          hasTasks: hasTasks,
          hasAiItems: hasAiMacros || hasAiActions
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (!result) {
          return;
        }

        if (result.isComplete == false) {
          estimate.state = this.estimationState.INCOMPLETE;
          estimate.noToolsJustification = '';
        } else if (result.isComplete == true) {
          estimate.state = this.estimationState.COMPLETE;
          estimate.noToolsJustification = result.justification;
        }

        if (this.isUpdate) {
          this.estimativaService.updateEstimate(this.dataService.getEstimate(), estimate).subscribe({
            next: (data) => {
              if (data.success) {
                this.infoBar.showSnackbar(this.variables.successfullyEditedEstimate, ['successful-snackbar'], 4000);
                this.clearAiData();

                if (this.estimate.state === this.estimationState.COMPLETE) {
                  this.notificationsService.refreshUnreadCountNow().subscribe();

                  const source = this.dataService.getEstimativaNavigationContext() as { origin?: string } | null;
                  if (source?.origin === "resultPage") {
                    this.router.navigate(['estimativa/resultado']);
                  }
                  else if (source?.origin === "combinedResultPage" || source?.origin === "projectPage") {
                    this.router.navigate(['/projecto']);
                  }
                  else {
                    this.router.navigate(['/dashboard']);
                  }

                  this.dataService.clearEstimativaNavigationContext();
                }
                else {
                  this.router.navigate(['/dashboard']);
                }
              }
            },
            error: (error) => {
              console.error('Error:', error.error);
              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
            }
          });
        } else {
          this.estimativaService.saveEstimate(estimate).subscribe({
            next: (data) => {
              if (data.success) {
                this.clearAiData();
                this.infoBar.showSnackbar(this.variables.successfullyAddedEstimate, ['successful-snackbar'], 4000);
                const source = this.dataService.getEstimativaNavigationContext() as { origin?: string } | null;
                if (source?.origin === 'projectPage') {
                  this.dataService.clearEstimativaNavigationContext();
                  this.router.navigate(['/projecto']);
                } else {
                  this.router.navigate(['estimativa/resultado']);
                }
              }
            },
            error: (error) => {
              console.error('Error:', error.error);
              const message = this.errorMessages[error.error.message]
              this.infoBar.showSnackbar(message, ['error-snackbar'], 4000);
            }
          });
        }
      });

    }
  }

  validateControls(formGroup: any) {
    let valid = true

    // Validate each control
    if (formGroup.nameCtrl === '') {
      this.invalidFields.name = true;
      this.fieldsErrorMessages.name = this.variables.insertNameMessage;
      valid = false;

    }

    if (formGroup.critQuestion1Ctrl === '') {
      this.invalidFields.critQuestion1 = true;
      this.fieldsErrorMessages.critQuestion1 = this.variables.impactRequired;
      valid = false;
    }

    if (formGroup.critQuestion2Ctrl === '') {
      this.invalidFields.critQuestion2 = true;
      this.fieldsErrorMessages.critQuestion2 = this.variables.impactBusinessRequired;
      valid = false;
    }

    if (formGroup.projectCtrl === '') {
      this.invalidFields.project = true;
      this.fieldsErrorMessages.project = this.variables.projectRequired;
      valid = false;
    }

    if (formGroup.catalogCtrl === '') {
      this.invalidFields.catalog = true;
      this.fieldsErrorMessages.catalog = this.variables.catalogRequired;
      valid = false;
    }

    if (formGroup.metodologyProjectCtrl === '') {
      this.invalidFields.projectMethodology = true;
      this.fieldsErrorMessages.projectMethodology = this.variables.selectMetodology;
      valid = false;
    }

    if (!this.checkIfSelectedGeneric(formGroup.projectTypeCtrl)) {
      this.invalidFields.projectType = true;
      this.fieldsErrorMessages.projectType = this.variables.chooseProjectType;
      valid = false;
    }

    // if (!this.checkIfSelectedGeneric(formGroup.configurationCtrl)) { 
    //   this.invalidFields.configuration = true;
    //   this.fieldsErrorMessages.configuration = this.variables.atLeastOneConfig;
    //   valid = false;
    // }

    // if (!this.checkIfSelectedGeneric(formGroup.parametersCtrl)) { 
    //   this.invalidFields.parameters = true;
    //   this.fieldsErrorMessages.parameters = this.variables.selectParams;
    //   valid = false;
    // }

    //if (!this.checkIfSelectedGeneric(formGroup.macroTypeCtrl)) { 
    //  this.invalidFields.macroType = true;
    //  this.fieldsErrorMessages.macroType = this.variables.selectMetodology;
    //  valid = false;
    //}

    return valid
  }


  validateControlsExtra(formGroup: any): boolean {
    let valid = true

    if (formGroup.estimateModelCtrl === '' && formGroup.metodologyProjectCtrl.toLowerCase() === "agile") {
      this.invalidFields.agileModels = true;
      this.fieldsErrorMessages.agileModels = this.variables.estimateModelRequired;
      valid = false
    }

    // 'macros' is treated as a special case, only called if macroTypeCtrl is selected
    if (!this.checkIfSelectedMacro(formGroup.macroTypeCtrl) && this.checkIfSelectedGeneric(formGroup.macroTypeCtrl)) {
      this.invalidFields.macro = true;
      this.fieldsErrorMessages.macro = this.variables.selectMacroActivities;
      valid = false
    }

    return valid
  }

  checkIfSelectedGeneric(control: any): boolean {
    return control.find((element: any) => element.selected === true);
  }

  checkIfSelectedMacro(control: any): boolean {
    return control.some(((element: any) => element.selected === true));
  }

  cleanErrors() {
    this.invalidFields.name = false;
    this.invalidFields.critQuestion1 = false;
    this.invalidFields.critQuestion2 = false;
    this.invalidFields.project = false;
    this.invalidFields.catalog = false;
    this.invalidFields.projectMethodology = false;
    this.invalidFields.agileModels = false;
    this.invalidFields.technology = false;
    this.invalidFields.projectType = false;
    this.invalidFields.configuration = false;
    this.invalidFields.parameters = false;
    this.invalidFields.macroType = false;
    this.invalidFields.macro = false;

    this.fieldsErrorMessages.name = ''
    this.fieldsErrorMessages.critQuestion1 = ''
    this.fieldsErrorMessages.critQuestion2 = ''
    this.fieldsErrorMessages.project = ''
    this.fieldsErrorMessages.catalog = ''
    this.fieldsErrorMessages.projectMethodology = ''
    this.fieldsErrorMessages.agileModels = ''
    this.fieldsErrorMessages.technology = ''
    this.fieldsErrorMessages.projectType = ''
    this.fieldsErrorMessages.configuration = ''
    this.fieldsErrorMessages.parameters = ''
    this.fieldsErrorMessages.macroType = ''
    this.fieldsErrorMessages.macro = ''
  }

  //Goes to the 2 phase - now emits event to parent instead
  activity() {

    //clean up originalSubTasks as phase 2 takes over
    this.originalSubTasks = []
    this.cleanErrors()

    const formGroup = this.estimativaForm.value;

    if (!this.validateControlsExtra(formGroup) || !this.validateControls(formGroup)) {
      this.infoBar.showSnackbar(this.variables.errorInForm, ['error-snackbar'], 4000);
      return;
    }

    if (this.estimativaForm.status === 'VALID') {
      // Create the estimate object
      const estimate = this.setEstimate('null', "isActivity");

      // Emit event to parent to switch to phase 2 (activities) with all necessary data
      this.goToActivitiesEvent.emit({
        estimate: estimate,
        technology: this.techId,
        originalProject: this.originalProject,
        isUpdate: this.isUpdate,
        idEstimate: this.idEstimate,
        subTasks: estimate.subTasks,
        modifiedSubTasks: this.modifiedSubTasks,
        subTasksAiWarning: this.subTasksAiWarning
      });
    } else {
      this.infoBar.showSnackbar(this.variables.snackBarMandatoryFieldsMessage, ['error-snackbar'], 4000);
    }
  }

  atLeastOneOptionSelectedValidator(): ValidatorFn {
    return (formArray: AbstractControl): ValidationErrors | null => {
      const isAnySelected = (formArray as FormArray).controls.some(control => control.get('selected')?.value === true);
      return isAnySelected ? null : { atLeastOneOptionSelected: true };
    };
  }

  atLeastOneQuestionSelectedValidator(): ValidatorFn {
    return (formArray: AbstractControl): ValidationErrors | null => {
      const isAnySelected = (formArray as FormArray).controls.some(control => control.get('selected')?.value === true);
      return isAnySelected ? null : { atLeastOneQuestionSelected: true };
    };
  }

  atLeastOneMacroSelectedValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const macrosArray = control as FormArray;
      const isAnyMacroSelected = macrosArray.controls.some(macroCtrl => macroCtrl.get('selected')?.value === true);
      return isAnyMacroSelected ? null : { atLeastOneMacroSelected: true };
    };
  }

  removeALLAiSubTaskReferences() {

    this.removeAiGeneratedSubTasks()
    this.dataService.clearAiGeneratedActionItems();
    this.dataService.clearAiModifieddActionItems();

  }

  removeALLAiReferences() {

    this.removeAiGeneratedSubTasks()
    this.removeAiGeneratedMacrosFromForm();

    this.clearAiData();

    this.showAiMacroWarning = false;
    this.hasDisplayedAiMacroWarning = false;
    this.dataService.setShowAiMacroWarning(false);
  }

  onChangeTechCatalog(catalog: any, estimate?: any) {  
    
    this.isCatalogSelected = true;
    this.getCatalogById(catalog, estimate)
  }

  hasRequiredValidator(control: AbstractControl | null): boolean {
    if (!control) return false;
    const validator = control.validator ? control.validator({} as AbstractControl) : null;
    return validator && validator['required'] ? true : false;
  }

  gcmValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;

    // Allow empty value (optional field)
    if (value === null || value === undefined || value === '') {
      return null; // No error if empty
    }

    // Ensure the value is a single digit (0-9)
    if (!/^[0-9]$/.test(value.toString())) {
      return { invalidGcm: true }; // Return error object
    }

    return null; // Valid input
  }


  filterTasks() {
    this.currentSelectedCatalog.tasks.forEach((task: any) => {
      const objectByAction = this.filteredTasks.some((item: any) => item.action == task.action);
      if (!objectByAction) {
        this.filteredTasks.push({
          action: task.action,
          macros: [{
            name: task.macro
          }]
        })
      }
      else {
        const index = this.filteredTasks.findIndex((item: any) => item.action == task.action);
        const objectByMacro = this.filteredTasks[index].macros.some((item: any) => item.name == task.macro);
        if (!objectByMacro) {
          this.filteredTasks[index].macros.push({
            name: task.macro
          })
        }
      }
    })
  }

  createQuestionControl() {
    const questionsFormArray = this.estimativaForm.get('questions') as FormArray;
    questionsFormArray.clear();
    questionsFormArray.setValidators(this.atLeastOneQuestionSelectedValidator());
    //const questionsFormArray = this.fb.array([], this.atLeastOneQuestionSelectedValidator()); // Attach the validator to questionsFormArray
    //this.estimativaForm.setControl('questions', questionsFormArray);

    this.currentSelectedCatalog.questions.forEach((question: any, questionIndex: any) => {
      if (question.questionRelatedTo === 'tasks') {
        const actionArray = this.fb.array([]);

        this.filteredTasks.forEach((action: any) => {
          const macroArray = this.fb.array([]);

          action.macros.forEach((macro: any) => {
            macroArray.push(this.fb.group({
              selected: [false],
              optionName: [{ value: macro.name }],
              quantity: [{ value: '', disabled: true }, Validators.required],
              tariff: [{ value: '', disabled: true }]
            }) as any);
          });

          const actionGroup = this.fb.group({
            selected: [false], // Checkbox for this action
            optionName: [{ value: action.action }],
            macros: macroArray
          });

          // Conditionally apply the validator to the macroArray
          actionGroup.get('selected')?.valueChanges.subscribe((isChecked) => {
            if (isChecked) {
              macroArray.setValidators(this.atLeastOneMacroSelectedValidator());
            } else {
              macroArray.clearValidators();
            }
            macroArray.updateValueAndValidity(); // Trigger validation update
          });

          actionArray.push(actionGroup as any);
        });

        const questionGroup = this.fb.group({
          selected: [false], // Main checkbox for the question
          optionsArray: actionArray // Attach the FormArray
        });

        // Only validate `actionArray` when the question's main checkbox is checked
        questionGroup.get('selected')?.valueChanges.subscribe((isChecked) => {
          if (this.isCheckboxTouched == false) {
            this.isCheckboxTouched = true;
          }
          if (isChecked) {
            actionArray.setValidators(this.atLeastOneOptionSelectedValidator());
          } else {
            actionArray.clearValidators();
          }
          actionArray.updateValueAndValidity(); // Update the taskArray validation
        });

        questionsFormArray.push(questionGroup);
      }
      else if (question.questionRelatedTo === 'components' && question.typeOfQuestion === 'multi-option-multi-answer') {
        // Add a FormArray for components with checkboxes and quantities
        const componentArray = this.fb.array([]);
        this.currentSelectedCatalog.licensings[question.componentRelation].items.forEach((item: any) => {
          let max = 0;
          if (item.interval != null) {
            max = this.getMaxQuantityBasedOnInterval(item, question.componentRelation);
          }
          if (max == 0) {
            componentArray.push(this.fb.group({
              selected: [false],
              optionName: [{ value: item.name }],
              quantity: [{ value: '', disabled: true }, [Validators.required, Validators.min(1)]],
              period: [{ value: '', disabled: true }, [Validators.required]],
              tariff: [{ value: '', disabled: true }]
            }) as any);
          }
          else if (max > 0) {
            componentArray.push(this.fb.group({
              selected: [false],
              optionName: [{ value: item.name }],
              quantity: [{ value: '', disabled: true }],
              period: [{ value: '', disabled: true }, [Validators.required, Validators.max(this.getMaxQuantityBasedOnInterval(item, question.componentRelation)), Validators.min(1)]],
              tariff: [{ value: '', disabled: true }]
            }) as any);
          }
        });

        // Main checkbox for the question, and attach the taskArray validator conditionally
        const questionGroup = this.fb.group({
          selected: [false], // Checkbox for this question
          optionsArray: componentArray // Attach the FormArray
        });

        // Only validate `taskArray` when the question's main checkbox is checked
        questionGroup.get('selected')?.valueChanges.subscribe((isChecked) => {
          if (this.isCheckboxTouched == false) {
            this.isCheckboxTouched = true;
          }
          if (isChecked) {
            componentArray.setValidators(this.atLeastOneOptionSelectedValidator());
          } else {
            componentArray.clearValidators();
          }
          componentArray.updateValueAndValidity(); // Update the taskArray validation
        });

        questionsFormArray.push(questionGroup);
      }
      else if (question.questionRelatedTo === 'components' && question.typeOfQuestion === 'open-value') {

        // Add a single input field for open-value questions
        const item1 = this.getItemFromLicenses(question);
        let max = 0;

        if (item1[0].interval != null) {
          max = this.getMaxQuantityBasedOnInterval(item1[0], question.componentRelation);
        }

        let questionGroup: FormGroup;

        if (max == 0) {
          questionGroup = this.fb.group({
            selected: [false],
            quantity: [''],
            period: [''],
            tariff: ['']
          });
        }
        else {
          questionGroup = this.fb.group({
            selected: [false],
            quantity: [''],
            period: [''],
            tariff: ['']
          });
        }

        questionsFormArray.push(questionGroup);

        questionGroup.get('selected')?.valueChanges.subscribe((isChecked) => {
          const quantityControl = questionGroup.get('quantity');
          const periodControl = questionGroup.get('period');

          if (isChecked) {
            if (max == 0) {
              quantityControl?.setValidators([Validators.required, Validators.min(1)]);
            }
            else {
              quantityControl?.setValidators([Validators.required, Validators.min(1), Validators.max(max)]);
            }
            periodControl?.setValidators([Validators.required]);
            quantityControl?.enable();
            periodControl?.enable();
          } else {
            quantityControl?.clearValidators();
            periodControl?.clearValidators();
            quantityControl?.disable();
            periodControl?.disable();
          }

          // Update the controls' validity state
          quantityControl?.updateValueAndValidity();
          periodControl?.updateValueAndValidity();
        });

      }
    });
    this.estimativaForm.removeControl('configurationCtrl');
    this.estimativaForm.removeControl('macroCtrl');
    this.estimativaForm.removeControl('macroTypeCtrl');
    this.estimativaForm.removeControl('projectTypeCtrl');
  }

  clearSelectedValue() {
    this.estimativaForm.get('riskCtrl')?.reset();
  }

  licensesWithoutSameName(licenses: any) {
    let result: any[] = [];
    licenses.forEach((license: any) => {
      !result.some((item: any) => item.name == license.name) && result.push(license);
    })
    return result;
  }

  getMaxQuantityBasedOnInterval(item: any, license: number) {
    let result = 0;
    if (item.interval != null) {
      const filters = this.currentSelectedCatalog.licensings[license].items;
      filters.forEach((filter: any) => {
        if (filter.interval[1] > result) {
          result = filter.interval[1]
        }
      })
    }
    return result;
  }

  getItemFromLicenses(question: any) {
    return this.currentSelectedCatalog.licensings[question.componentRelation].items;
  }

  onCheckboxChangeService(arrayIndex: number, controlIndex: number, isChecked: boolean) {
    const formArray = (this.estimativaForm.get('questions') as FormArray).at(arrayIndex).get('optionsArray') as FormArray;
    const control = formArray.at(controlIndex);

    if (isChecked) {
      control.get('quantity')?.enable();
      control.get('period')?.enable();
      control.get('tariff')?.enable();
    } else {
      control.get('quantity')?.disable();
      control.get('quantity')?.setValue('');
      control.get('period')?.disable();
      control.get('period')?.setValue('');  // Clear value when unchecked
      control.get('tariff')?.disable();
      control.get('tariff')?.setValue('');
    }
  }

  updateValidatosForOpenValueQuestions() {

  }

  onCheckboxChangeTasks(arrayIndex: number, actionIndex: number, macroIndex: number, isChecked: boolean) {
    const formArray = (this.estimativaForm.get('questions') as FormArray).at(arrayIndex).get('optionsArray') as FormArray;
    const control = (formArray.at(actionIndex).get('macros') as FormArray)?.at(macroIndex);

    if (isChecked) {
      control.get('quantity')?.enable();
      control.get('tariff')?.enable();
    }
    else {
      control.get('quantity')?.disable();
      control.get('quantity')?.setValue('');
      control.get('tariff')?.disable();
      control.get('tariff')?.setValue('');
    }
  }

  // When a technology is selected, it updates all the sections.
  onChangeTech(tech: any) {

    if (this.isUpdate) {
      this.isCatalogSelected = true;
    }

    if (Object.keys(this.estimate).length != 0) {
      let selectedTech = {} as Tecnologia;
      this.technologies.forEach((element: Tecnologia) => {
        if (element.name === tech) selectedTech = element;
      });

      if (Object.keys(selectedTech).length === 0) {
        return;
      }

      this.macrosTypes = [];
      this.macrosNames = [];
      selectedTech.macroActivities.forEach((macro: any) => {
        if (!this.macrosTypes.find((m: any) => m.type == macro.type)) {
          this.macrosTypes.push({ type: macro.type });
          this.showNames.push(false);
        }
      });

      this.macrosTypes.forEach((macro: any) => {
        var filterMacros = selectedTech.macroActivities.filter((macro1: any) => macro1.type == macro.type);
        this.macrosNames.push(filterMacros);
      });

      this.estimate.macroActivities.forEach((item: any) => {
        item.checked = true;
      });

      const objetosAusentes = this.estimate.macroActivities.filter((item: any) => {
        return !this.macrosNames.some((abc: any) =>
          abc.some((obj: any) => obj.name === item.name)
        );
      });

      function addToSubArr(objeto: any, subArray: any) {
        const index = subArray.findIndex((item: any) => item.type === objeto.type);

        if (index !== -1) {
          objeto.styleField = "colorGray";
          subArray.splice(index, 0, objeto);
        } else {
          subArray.push([{ ...objeto, styleField: "colorGray" }]);
        }
      }

      objetosAusentes.forEach((objetoAusente: any) => {
        if (objetoAusente.type) {
          const subArrayCorrespondente = this.macrosNames.find((subArray: any) =>
            subArray.some((obj: any) => obj.type === objetoAusente.type)
          );

          if (subArrayCorrespondente) {
            addToSubArr(objetoAusente, subArrayCorrespondente);
          } else {
            this.macrosNames.push([{ ...objetoAusente, styleField: "colorGray" }]);
          }
        }
      });


      //TIPO DE PROJECTO
      let projTypesFromTech = selectedTech ? selectedTech['projectTypes'] : null;
      let projectTypeToAdd = this.estimate.projectType;
      if (projTypesFromTech && projectTypeToAdd) {
        let isPresent = projTypesFromTech.some((entry: any) => entry.name === projectTypeToAdd.name);
        if (!isPresent) {
          projectTypeToAdd.styleField = "colorGray";
          projTypesFromTech = [projectTypeToAdd, ...projTypesFromTech];
        }
      }

      this.projectTypes = projTypesFromTech;


      //CONFIGURAÇÕES
      let configsFromTech = selectedTech ? selectedTech['configurations'] : null;
      if (this.estimate.configurations && configsFromTech) {
        let entriesNotInAbc = this.estimate.configurations.filter((entry: any) => !configsFromTech.some((abcEntry: any) => abcEntry.name === entry.name));
        entriesNotInAbc.forEach((entry: any) => {
          entry.styleField = "colorGray";
        });
        this.configurations = [...entriesNotInAbc, ...configsFromTech];
      } else {
      }


      //PARAMETROS
      let paramsFromTech = selectedTech ? selectedTech['parameters'] : null;
      if (this.estimate.parameters && paramsFromTech) {
        let entriesNotInAbc = this.estimate.parameters.filter((entry: any) => !paramsFromTech.some((abcEntry: any) => abcEntry.name === entry.name));
        entriesNotInAbc.forEach((entry: any) => {
          entry.styleField = "colorGray";
        });
        this.parameters = [...entriesNotInAbc, ...paramsFromTech];
      } else {
      }

    }
    else {
      let selectedTech = {} as Tecnologia;
      this.technologies.forEach((element: Tecnologia) => {
        if (element.name === tech) selectedTech = element;
      });

      if (Object.keys(selectedTech).length === 0) {
        return;
      }

      this.macrosTypes = [];
      this.macrosNames = [];
      selectedTech.macroActivities.forEach((macro: any) => {
        if (!this.macrosTypes.find((m: any) => m.type == macro.type)) {
          this.macrosTypes.push({ type: macro.type });
          this.showNames.push(false);
        }
      });

      this.macrosTypes.forEach((macro: any) => {
        var filterMacros = selectedTech.macroActivities.filter((macro1: any) => macro1.type == macro.type);
        this.macrosNames.push(filterMacros);
      });


      // Set all sections
      this.projectTypes = selectedTech ? selectedTech['projectTypes'] : null;
      this.configurations = selectedTech ? selectedTech['configurations'] : null;
      this.parameters = selectedTech ? selectedTech['parameters'] : null;
    }

  }

  changeShowNames(i: any, value?: boolean) {

    if (value != undefined) {
      this.showNames[i] = value;
    }
    else {
      if (this.showNames[i] == false) {
        this.showNames[i] = true;
      }
      else if (this.showNames[i] == true) {
        this.showNames[i] = false;
        for (var j = 0; j < this.macrosNames[i].length; j++) {
          this.macrosNames[i][j].checked = false;
          var index = this.estimativaForm.get('macroCtrl').value.indexOf(this.macrosNames[i][j]);
          this.estimativaForm.get('macroCtrl').value.splice(index, index + 1);
        }
      }
    }

  }

  // Recieves the event and the form control.
  // It will trigger when the checkbox is selected, it will add the value or remove it from the control arr.
  onCheckboxChange(e: any, ctrl: string) {

    // Get control
    const checkArray: FormArray = this.estimativaForm.get(ctrl) as FormArray;

    //Add in arr
    if (e.checked) {
      checkArray.push(new FormControl({ "name": e.source.value.name, "complexity": e.source.value.complexity }));
    }
    //Remove from arr
    else {
      let i: number = 0;

      checkArray.controls.forEach((item: any) => {
        if (item.value.name == e.source.value.name && item.value.complexity == e.source.value.complexity) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  // Set estimate object based on the form.
  setEstimate(s: string, typeOfSave: string) {
    const projectType = this.estimativaForm.get('projectTypeCtrl') as FormArray;
    const selectedProjectType = projectType.controls
      .filter((group: any) => group.get('selected')?.value)
      .map((group: any) => ({
        name: group.get('name')?.value,
        risk: group.get('risk')?.value
      }));

    const configurations = this.estimativaForm.get('configurationCtrl') as FormArray;
    const selectedConfigurations = configurations.controls
      .filter((group: any) => group.get('selected')?.value)
      .map((group: any) => ({
        name: group.get('name')?.value,
        complexity: group.get('complexity')?.value,
        profileId: group.get('profileId')?.value || null
      }));

    const parameters = this.estimativaForm.get('parametersCtrl') as FormArray;
    const selectedParameters = parameters.controls
      .filter((group: any) => group.get('selected')?.value)
      .map((group: any) => ({
        name: group.get('name')?.value,
        complexity: group.get('complexity')?.value,
        profileId: group.get('profileId')?.value || null
      }));

    const macroActivities = this.estimativaForm.get('macroTypeCtrl') as FormArray;
    const methodology = this.estimativaForm.value.metodologyProjectCtrl;
    const selectedMacros = macroActivities.controls
      .filter((macro: any) => macro.get('selected')?.value)
      .map((macro: any) => ({
        name: macro.get('name')?.value,
        effort: macro.get('effort')?.value,
        profileId: macro.get('profileId')?.value || null,
        maxHours: macro.get('maxHours')?.value || null,
        aiGenerated: macro.get('aiGenerated')?.value || false
      }));

    const macroActivitiesData = selectedMacros.length > 0 ? [{
      metodology: methodology,
      macroActivities: selectedMacros
    }] : [];

    let estimate = {
      id: null,
      name: this.estimativaForm.get('nameCtrl')?.value,
      criticality: {
        complexity1: this.estimativaForm.get('critQuestion1Ctrl')?.value,
        complexity2: this.estimativaForm.get('critQuestion2Ctrl')?.value
      },
      project: this.estimativaForm.get('projectCtrl')?.value,
      catalog: this.estimativaForm.get('catalogCtrl')?.value,
      projectMetodology: this.estimativaForm.get('metodologyProjectCtrl')?.value,
      estimateMode: this.estimativaForm.get('metodologyProjectCtrl')?.value.toLowerCase() == "agile" ? this.estimativaForm.get('estimateModelCtrl')?.value : null,
      projectType: selectedProjectType[0],
      configurations: selectedConfigurations,
      parameters: selectedParameters,
      macroActivities: macroActivitiesData,
      subTasks: [] as any[],
      state: this.estimationState.INCOMPLETE,
      noToolsJustification: '',
      profileSnapshots: [],
      ownerId: this.creator
    }

    // Add AI-generated action items
    const aiActionItemsData = this.dataService.getAiGeneratedActionItems();
    // Only merge if estimateId matches or is not set
    if (this.estimate && this.estimate.id == aiActionItemsData?.estimateId) {
      const aiActionItems = aiActionItemsData?.actionItems;
      if (aiActionItems && aiActionItems.length > 0) {

        // Remove duplicates: filter out AI-generated items that already exist in subTasks
        const aiAGenertedItems = aiActionItemsData?.actionItems;
        const uniqueNewItems = aiAGenertedItems.filter((newItem: any) => 
          !this.estimate.subTasks.some((existingItem: any) => existingItem.task === newItem.task && existingItem.subTask === newItem.subTask)
        );
        this.estimate.subTasks = [...this.estimate.subTasks, ...uniqueNewItems];


        this.estimate.subTasks = this.estimate.subTasks.filter((item: any, index: number, arr: any[]) => {
          const itemKey = JSON.stringify(item);
          return index === arr.findIndex((other: any) => JSON.stringify(other) === itemKey);
        });

        estimate.subTasks = this.estimate.subTasks;
      }
    }
    else if(this.estimativaForm.get('nameCtrl')?.value == aiActionItemsData?.estimateName) {
      estimate.subTasks = this.subTasks;
    }


    if (this.isUpdate) {
      estimate.id = this.estimate.id;
      estimate.subTasks = this.estimate.subTasks;
    }


    return estimate;

  }


  filterProjects() {
    if (!this.projects) {
      return;
    }
    let search = this.estimativaForm.get('projectFilterCtrl').value;
    if (!search) {
      this.filteredProjects = (this.projects.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredProjects = this.projects.filter((project: any) => project.name.toLowerCase().indexOf(search) > -1);
  }

  filterCatalogs() {
    if (!this.technologies) {
      return;
    }
    let search = this.estimativaForm.get('catalogFilterCtrl').value;
    if (!search) {
      this.filteredCatalogs = (this.technologies.slice());
      return;
    }
    else {
      search = search.toLowerCase();
    }

    this.filteredCatalogs = this.technologies.filter((tech: any) => tech.name.toLowerCase().indexOf(search) > -1);
  }

  getStyle(projectType: any): any {
    let style = {}

    if (projectType.selected && projectType.aiGenerated) {
      style = { 'background-color': 'lightblue' };
    }
    else if (projectType.styleField === 'colorGray') {
      style = { 'opacity': '0.5' };
    }
    return style;
  }

  openDialogEditValue(item: any) {
    // Store original values to find the item later
    const originalName = item.name;
    const originalRisk = item.risk;

    // Get the catalog's original value for this project type name
    const catalogOriginalValue = this.catalogProjectTypesMap.get(item.name);

    const dialogRef = this.dialog.open(EditValueDialogComponent, {
      data: {
        title: this.variables.changeTypeValue,
        itemName: item.name,
        itemRisk: item.risk,
        catalogOriginalValue: catalogOriginalValue
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const projectTypeCtrlArray = this.estimativaForm.get('projectTypeCtrl') as FormArray;

        // Find the original item that was edited
        const itemIndex = projectTypeCtrlArray['controls'].findIndex((project: any) =>
          project.value.name === originalName && project.value.risk === originalRisk
        );

        if (itemIndex !== -1) {
          // Update the existing item with new values
          projectTypeCtrlArray.at(itemIndex).get('name')?.setValue(result.itemName);
          projectTypeCtrlArray.at(itemIndex).get('risk')?.setValue(result.itemRisk);
          this.onProjectTypeSelected(itemIndex);
        }
      }
    });
  }

  getMetodologyTypesToDropDown(methodologies: any) {
    this.metodologyTypes = [];
    this.metodologyTypes.push(...methodologies.map((methodology: any) => {
      return { name: methodology.metodology, id: methodology.metodology.toLowerCase() };
    }));
  }


  goToDashboard() {
    this.router.navigate(['/dashboard']);
  }
}
